import { renderMilestoneName } from "@/models/Milestone"

import { Notification, NotificationMilestoneContent } from "./Notification"

export class NotificationMilestone extends Notification {
  constructor(props) {
    super(props)
  }

  get milestone() {
    return this.content?.milestone
  }

  get milestoneName() {
    return renderMilestoneName(this.milestone?.title ?? "")
  }

  get totalItemsCount() {
    return this.content?.totalItemsCount ?? this.milestone?.totalItemsCount ?? ""
  }

  get completedItemsCount() {
    return this.content?.completedItemsCount ?? this.milestone?.completedItemsCount ?? ""
  }

  get percentComplete() {
    const value = this.content?.percentComplete ?? this.milestone?.percentComplete
    return value != null ? Math.round(value) : ""
  }

  get url() {
    return this.content?.url ?? "#"
  }

  get mileStoneurl() {
    return this.content?.milestoneUrl || this.content?.url || "#"
  }

  get milestoneDate() {
    return `${this.milestone.startDate} - ${this.milestone.endDate}`
  }

  get projectName() {
    return this.content?.projectName ?? ""
  }

  get reminder() {
    return this.content?.reminder ?? false
  }

  get daysLeft() {
    const value = this.content?.daysLeft ?? 0
    return value < 0 ? 0 : value
  }

  get currentGoalContent() {
    return this.content?.currentGoalContent ?? ""
  }

  get moreFeaturesCount() {
    return this.content?.moreFeaturesCount ?? 0
  }

  get epicsCount() {
    return this.content?.epicsCount ?? 0
  }
}
